import { IconProps } from './types';

export const IconFreyaKnot = ({ size = 20, color = 'currentColor', ...props }: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
    <path
      d='M15.5 9.5H16.5C18.1569 9.5 19.5 8.15685 19.5 6.5C19.5 4.84315 18.1569 3.5 16.5 3.5C14.8431 3.5 13.5 4.84315 13.5 6.5V7.5M15.5 9.5H16.5M15.5 9.5V8.5M8.5 9.5H7.5C5.84315 9.5 4.5 8.15685 4.5 6.5C4.5 4.84315 5.84315 3.5 7.5 3.5C9.15685 3.5 10.5 4.84315 10.5 6.5V7.5M8.5 9.5H9.5M8.5 9.5V8.5M8.5 14.5H7.5C5.84315 14.5 4.5 15.8431 4.5 17.5C4.5 19.1569 5.84315 20.5 7.5 20.5C9.15685 20.5 10.5 19.1569 10.5 17.5V16.5M8.5 14.5H9.5M8.5 14.5V15.5M15.5 14.5H16.5C18.1569 14.5 19.5 15.8431 19.5 17.5C19.5 19.1569 18.1569 20.5 16.5 20.5C14.8431 20.5 13.5 19.1569 13.5 17.5V16.5M15.5 14.5H14.5M15.5 14.5V15.5M9.5 8.5V9.5M9.5 8.5H14.5M9.5 15.5V14.5M9.5 15.5H14.5M14.5 15.5V9.5M9.5 9.5V14.5'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M9 9H15V15H9V9Z' fill={color} fillOpacity='0.2' stroke='none' />
  </svg>
);
